import React from 'react'
import { useDispatch } from 'react-redux'
import Overlay from 'common/components/core/Overlay'
import { closePopup } from 'publisher/actionsManagement'
import { PopupNew } from 'publisher/components/entities/popup-new'
import { PopupVisibilityUi } from 'publisher/pages/ui/popup-visibility-controller-ui'
import { PopupWrapperUi } from 'publisher/pages/ui/popup-wrapper-ui'
import { useManagement, usePage } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { setCloseCookie } from 'publisher/utils/cookie'

export const TriggeredPopup = () => {
  const triggeredPopupId = useManagement(managementSelectors.getActivePopupId)
  const popups = usePage(pageSelectors.getPopupEntities)
  const pageId = usePage(pageSelectors.getPageId)
  const dispatch = useDispatch()

  const handleClose = (popupId: string, closedDays: number | undefined) => {
    setCloseCookie(pageId, popupId, closedDays)
    dispatch(closePopup)
  }

  return (
    <>
      {popups?.map(popup => (
        <PopupVisibilityUi
          data-testid={`popup-${popup.id}`}
          key={popup.id}
          isVisible={triggeredPopupId === popup.id}
        >
          <PopupWrapperUi>
            <PopupNew
              entity={popup}
              closePopup={() => handleClose(popup.id, popup.closedDays)}
            />
          </PopupWrapperUi>
          <Overlay dark />
        </PopupVisibilityUi>
      ))}
    </>
  )
}
